export default __webpack_public_path__ + "img/icon-fullscreen.a07b9267.svg";